import React from "react";
import { FaCheck } from "react-icons/fa";

function UnleashLending() {
  return (
    <div className="about-area pt-120 pb-120 overflow-hidden">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="thumb position-relative text-center">
              <div
                className="position-absolute translate-middle-y"
                style={{
                  width: "100%",
                  height: "100%",
                  background:
                    "radial-gradient(circle, rgba(33, 150, 243, 0.08), transparent)",
                  top: "50%",
                  left: "0",
                  zIndex: -1,
                }}
              ></div>
              <img
                src="/assets/img/illustration/2.png"
                alt="Unleash DeFi Power"
                className="img-fluid"
                style={{
                  borderRadius: "30px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                  animation: "subtlePulse 4s ease-in-out infinite",
                }}
              />
            </div>
          </div>
          <div className="col-lg-6 mt-5 mt-lg-0">
            <div className=" ps-lg-5">
              <span
                className="text-primary fw-bold text-uppercase mb-3 d-block"
                style={{ fontSize: "14px", letterSpacing: "2px" }}
              >
                Strategic Growth
              </span>

              <h2
                className="title fw-extrabold mb-4"
                style={{ fontWeight: "bold" }}
              >
                Unleash The Power of Decentralized Finance
              </h2>

              <div
                style={{
                  height: "4px",
                  width: "50px",
                  background: "#2196f3",
                  marginBottom: "30px",
                  borderRadius: "2px",
                }}
              ></div>

              <p className="fs-5 text-muted mb-4" style={{ lineHeight: "1.7" }}>
                Lending and borrowing are foundational pillars of a mature
                financial ecosystem. DeFi protocols bring these essential
                services to the blockchain, allowing anyone to lend assets and
                earn interest, or borrow against their holdings securely.
              </p>

              <div className="features-list">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary-soft p-2 rounded-circle me-3">
                    <FaCheck className="text-primary" />
                  </div>
                  <span className="fw-bold">
                    High-Speed Transaction Validation
                  </span>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary-soft p-2 rounded-circle me-3">
                    <FaCheck className="text-primary" />
                  </div>
                  <span className="fw-bold">No-Middleman Interest Accrual</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes subtlePulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.02); }
          100% { transform: scale(1); }
        }
        .bg-primary-soft { background-color: #eef6ff; }
      `}</style>
    </div>
  );
}

export default UnleashLending;
